/* HerNext supplement landing kit: gallery, buy box (live price, subscription options, add-ons), benefits accordion,
   ingredient tabs, bedtime planner, scroll reveal. Add to cart itself is sent by hernext.js (form[data-hn-atc]); this file adds the selling plan to that request. */
(function () {
  if (window.__hnSupp) return;
  window.__hnSupp = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!(window.Shopify && window.Shopify.designMode);

  function replay(el) {
    if (!el || reduce) return;
    el.classList.remove('hns-fade');
    void el.offsetWidth;
    el.classList.add('hns-fade');
  }
  function txt(el, s) { if (el && el.textContent !== s) el.textContent = s; }
  function define(name, cls) { if (!customElements.get(name)) customElements.define(name, cls); }

  function money(cents, format) {
    var fmt = String(format || '${{amount}}').replace(/<[^>]*>/g, '');
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    function f(d, t, s) {
      var p = (cents / 100).toFixed(d).split('.');
      return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t) + (p[1] ? s + p[1] : '');
    }
    var out = {
      amount: f(2, ',', '.'),
      amount_no_decimals: f(0, ',', '.'),
      amount_with_comma_separator: f(2, '.', ','),
      amount_no_decimals_with_comma_separator: f(0, '.', ','),
      amount_with_apostrophe_separator: f(2, "'", '.'),
      amount_with_space_separator: f(2, ' ', ','),
      amount_no_decimals_with_space_separator: f(0, ' ', ',')
    }[m ? m[1] : 'amount'] || f(2, ',', '.');
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, out);
  }

  /* ---------- Gallery ---------- */
  define('hns-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      var self = this;
      this.addEventListener('click', function (e) {
        var b = e.target.closest('[data-hns-thumb]');
        if (b && self.contains(b)) self.show(+b.getAttribute('data-hns-thumb'));
      });
    }
    show(i) {
      this.querySelectorAll('[data-hns-slide]').forEach(function (s) {
        var on = +s.getAttribute('data-hns-slide') === i;
        if (on && s.hidden) { s.hidden = false; replay(s); }
        else if (!on && !s.hidden) {
          s.hidden = true;
          s.querySelectorAll('video').forEach(function (v) { try { v.pause(); } catch (x) {} });
        }
      });
      this.querySelectorAll('[data-hns-thumb]').forEach(function (b) {
        b.setAttribute('aria-pressed', +b.getAttribute('data-hns-thumb') === i ? 'true' : 'false');
      });
    }
    select(el) {
      var s = el.closest('[data-hns-slide]');
      if (s) this.show(+s.getAttribute('data-hns-slide'));
    }
  });

  /* ---------- Accordion (benefits) ---------- */
  define('hns-accordion', class extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      var self = this;
      this.addEventListener('click', function (e) {
        var b = e.target.closest('[data-hns-acc-btn]');
        if (b && self.contains(b)) self.toggle(b.closest('[data-hns-acc-item]'));
      });
    }
    toggle(item, force) {
      if (!item) return;
      var b = item.querySelector('[data-hns-acc-btn]');
      var open = typeof force === 'boolean' ? force : b.getAttribute('aria-expanded') !== 'true';
      var self = this;
      if (open && this.hasAttribute('data-single')) {
        this.querySelectorAll('[data-hns-acc-item]').forEach(function (o) { if (o !== item) self.set(o, false); });
      }
      this.set(item, open);
    }
    set(item, open) {
      var b = item.querySelector('[data-hns-acc-btn]');
      var p = item.querySelector('[data-hns-acc-panel]');
      var was = b.getAttribute('aria-expanded') === 'true';
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (p) { p.hidden = !open; if (open && !was) replay(p); }
    }
    select(el) { this.toggle(el.closest('[data-hns-acc-item]'), true); }
  });

  /* ---------- Tabs (ingredient explorer) ---------- */
  define('hns-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      var self = this;
      this.addEventListener('click', function (e) {
        var t = e.target.closest('[role="tab"]');
        if (t && self.contains(t)) self.show(t.getAttribute('aria-controls'));
      });
      this.addEventListener('keydown', function (e) {
        var t = e.target.closest('[role="tab"]');
        if (!t) return;
        var tabs = [].slice.call(self.querySelectorAll('[role="tab"]'));
        var i = tabs.indexOf(t), n = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = tabs[(i + 1) % tabs.length];
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (e.key === 'Home') n = tabs[0];
        else if (e.key === 'End') n = tabs[tabs.length - 1];
        if (n) { e.preventDefault(); n.focus(); self.show(n.getAttribute('aria-controls')); }
      });
    }
    show(id) {
      this.querySelectorAll('[role="tab"]').forEach(function (t) {
        var on = t.getAttribute('aria-controls') === id;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      this.querySelectorAll('[role="tabpanel"]').forEach(function (p) {
        var on = p.id === id;
        if (on && p.hidden) { p.hidden = false; replay(p); }
        else if (!on) p.hidden = true;
      });
    }
    select(el) { var p = el.closest('[role="tabpanel"]'); if (p) this.show(p.id); }
  });

  /* ---------- Bedtime planner ---------- */
  define('hns-bedtime', class extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      var self = this;
      this.range = this.querySelector('input[type="range"]');
      if (!this.range) return;
      this.range.addEventListener('input', function () { self.update(); });
      this.update();
    }
    clock(min) {
      var start = +this.getAttribute('data-start') || 1200;
      var t = ((start + min) % 1440 + 1440) % 1440, h = Math.floor(t / 60), m = t % 60, mm = (m < 10 ? '0' : '') + m;
      if (this.getAttribute('data-format') === '24') return (h < 10 ? '0' : '') + h + ':' + mm;
      return (h % 12 || 12) + ':' + mm + ' ' + (h >= 12 ? 'PM' : 'AM');
    }
    update() {
      var v = +this.range.value;
      var wind = +this.getAttribute('data-wind') || 0;
      var a = +this.getAttribute('data-take-from') || 0, b = +this.getAttribute('data-take-to') || 0;
      var map = {
        bed: this.clock(v),
        wind: this.clock(v - wind),
        take: a === b ? this.clock(v - a) : this.clock(v - Math.max(a, b)) + ' – ' + this.clock(v - Math.min(a, b))
      };
      this.querySelectorAll('[data-hns-time]').forEach(function (el) { el.textContent = map[el.getAttribute('data-hns-time')]; });
      this.range.setAttribute('aria-valuetext', map.bed);
    }
  });

  /* ---------- Buy box ---------- */
  define('hns-buy', class extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      var self = this;
      try { this.data = JSON.parse(this.querySelector('[data-hns-json]').textContent); } catch (e) { this.data = { variants: [] }; }
      this.form = this.querySelector('form');
      if (!this.form) return;

      this.addEventListener('click', function (e) {
        var q = e.target.closest('[data-hns-qty]');
        if (!q || !self.contains(q)) return;
        e.preventDefault();
        var inp = self.form.querySelector('input[name="quantity"]');
        if (inp) inp.value = (parseInt(inp.value, 10) || 1) + (+q.getAttribute('data-hns-qty'));
        self.update();
      });
      this.form.addEventListener('change', function () { self.update(); });
      this.form.addEventListener('input', function (e) { if (e.target.name === 'quantity') self.update(true); });
      document.addEventListener('hernext:cart-added', function () { self.update(); });

      // Subscription app widgets may change the selling_plan field without firing events: watch the form.
      if ('MutationObserver' in window) {
        var queued = false;
        new MutationObserver(function () {
          if (queued) return;
          queued = true;
          requestAnimationFrame(function () { queued = false; self.update(); });
        }).observe(this.form, { subtree: true, childList: true, attributes: true, attributeFilter: ['value', 'checked', 'disabled'] });
      }

      // Shopify answers "sold out" when a shipped item cannot reach the shopper's country: explain it instead.
      var errEl = this.form.querySelector('[data-hn-atc-error]');
      var shipMsg = this.getAttribute('data-ship-error');
      if (errEl && shipMsg && 'MutationObserver' in window) {
        new MutationObserver(function () {
          if (errEl.hidden || !/sold out/i.test(errEl.textContent) || errEl.textContent === shipMsg) return;
          if (self.variant() && self.variant().available) errEl.textContent = shipMsg;
        }).observe(errEl, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
      }
      this.update();
    }

    variant() {
      var el = this.form.querySelector('[name="id"]');
      var id = el ? +el.value : 0, vs = this.data.variants || [];
      for (var i = 0; i < vs.length; i++) if (vs[i].id === id) return vs[i];
      return vs[0];
    }

    planId() {
      var r = this.form.querySelector('input[data-hns-plan]:checked');
      if (r) return r.value;
      var sp = this.form.querySelector('[name="selling_plan"]');
      return sp && !sp.disabled ? sp.value : '';
    }

    update(typing) {
      var v = this.variant();
      if (!v) return;
      var fmt = this.data.money_format;
      var pid = this.planId();

      // Native subscription options write the chosen plan into the selling_plan field
      var hidden = this.form.querySelector('input[data-hns-plan-input]');
      if (hidden) {
        if (hidden.value !== pid) hidden.value = pid;
        if (hidden.disabled !== !pid) hidden.disabled = !pid;
      }
      this.form.querySelectorAll('input[data-hns-plan]').forEach(function (r) {
        var l = r.closest('.hns-plan');
        if (l) l.classList.toggle('is-on', r.checked);
      });

      var a = pid && v.plans ? v.plans[pid] : null;
      var unit = a ? a.price : v.price;
      var was = a ? Math.max(a.compare || 0, v.price) : (v.compare || 0);
      if (was <= unit) was = 0;

      var now = this.querySelector('[data-hns-price]');
      txt(now, money(unit, fmt));
      var wasEl = this.querySelector('[data-hns-was]');
      if (wasEl) { wasEl.hidden = !was; txt(wasEl, was ? money(was, fmt) : ''); }
      var save = this.querySelector('[data-hns-save]');
      if (save) {
        var pct = a && was ? Math.round((was - unit) * 100 / was) : 0;
        save.hidden = !pct;
        if (pct) txt(save, (save.getAttribute('data-template') || 'Save [percent]').replace('[percent]', pct + '%'));
      }

      // Price shown on each purchase option
      this.querySelectorAll('[data-hns-plan-price]').forEach(function (el) {
        var id = el.getAttribute('data-hns-plan-price');
        var pa = id && v.plans ? v.plans[id] : null;
        var p = id ? (pa ? pa.price : null) : v.price;
        var w = id ? v.price : (v.compare || 0);
        var n = el.querySelector('[data-now]'), s = el.querySelector('[data-was]');
        if (n) txt(n, p == null ? '' : money(p, fmt));
        if (s) { var show = p != null && w > p; s.hidden = !show; txt(s, show ? money(w, fmt) : ''); }
      });

      // Quantity
      var qEl = this.form.querySelector('input[name="quantity"]');
      var qty = 1;
      if (qEl) {
        var max = parseInt(qEl.getAttribute('max'), 10) || 99;
        var raw = parseInt(qEl.value, 10);
        if (typing && isNaN(raw)) qty = 1;
        else {
          qty = Math.max(1, Math.min(max, raw || 1));
          if (String(qEl.value) !== String(qty)) qEl.value = qty;
        }
      }

      // Add-ons: checked boxes carry the variant id (hernext.js adds every non-empty hn_extra_id)
      var n = 0;
      this.form.querySelectorAll('input[name="hn_extra_id"]').forEach(function (c) {
        var want = c.checked ? (c.getAttribute('data-variant-id') || '') : '';
        if (c.value !== want) c.value = want;
        var t = c.closest('.hns-toggle');
        if (t) t.classList.toggle('is-on', c.checked);
        if (c.checked) n++;
      });

      // Button
      var btn = this.form.querySelector('[type="submit"]');
      if (btn && !btn.hasAttribute('aria-busy') && btn.disabled !== !v.available) btn.disabled = !v.available;
      var lab = this.querySelector('[data-hns-label]');
      txt(lab, v.available ? this.getAttribute('data-label') : this.getAttribute('data-soldout'));
      var tw = this.querySelector('[data-hns-total-wrap]');
      if (tw) tw.hidden = !v.available;
      var tot = this.querySelector('[data-hns-total]');
      txt(tot, money(unit * qty, fmt));
      var adds = this.querySelector('[data-hns-addons]');
      if (adds) {
        var tpl = n === 1 ? (this.getAttribute('data-addon-one') || '+ [N] add-on') : (this.getAttribute('data-addon-many') || '+ [N] add-ons');
        txt(adds, n ? ' ' + tpl.replace('[N]', n) : '');
      }
    }
  });

  /* ---------- Subscriptions with the shared add-to-cart (hernext.js) ---------- */
  // hernext.js posts {id, quantity} to /cart/add.js. For hn-supp buy boxes, add the chosen selling plan
  // (native options or a subscription app widget) and any line-item properties to that same request.
  var pending = null;
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.closest || !form.closest('hns-buy')) return;
    var fd = new FormData(form), sp = fd.get('selling_plan'), props = {}, hasProps = false;
    fd.forEach(function (v, k) {
      var m = k.match(/^properties\[(.+)\]$/);
      if (m && v !== '') { props[m[1]] = v; hasProps = true; }
    });
    pending = (sp || hasProps) ? { id: Number(fd.get('id')), plan: sp ? Number(sp) : null, props: hasProps ? props : null, t: Date.now() } : null;
  }, true);
  if (window.fetch && !window.fetch.__hns) {
    var nativeFetch = window.fetch;
    var hnsFetch = function (input, init) {
      if (pending) {
        try {
          var url = typeof input === 'string' ? input : (input && input.url) || '';
          if (/\/cart\/add(\.js)?(\?|$)/.test(url) && init && typeof init.body === 'string') {
            var body = JSON.parse(init.body), it = body.items && body.items[0];
            if (it && Number(it.id) === pending.id && Date.now() - pending.t < 15000) {
              if (pending.plan) it.selling_plan = pending.plan;
              if (pending.props) it.properties = Object.assign({}, it.properties || {}, pending.props);
              init = Object.assign({}, init, { body: JSON.stringify(body) });
            }
            pending = null;
          }
        } catch (x) { pending = null; }
      }
      return nativeFetch.apply(window, [input, init]);
    };
    hnsFetch.__hns = true;
    window.fetch = hnsFetch;
  }

  /* ---------- Theme editor: selecting a block reveals it ---------- */
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    var host = el && el.closest && el.closest('hns-gallery, hns-accordion, hns-tabs');
    if (host && typeof host.select === 'function') host.select(el);
  });

  /* ---------- Smooth in-page links (hernext.js already handles #hn-… links) ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.hns a[href^="#"]');
    if (!a) return;
    var h = a.getAttribute('href');
    if (h.length < 2 || h.indexOf('#hn-') === 0) return;
    var t = document.getElementById(h.slice(1));
    if (!t) return;
    e.preventDefault();
    t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    if (history.replaceState) history.replaceState(null, '', h);
  });

  /* ---------- Fade-in on scroll ---------- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      en.target.classList.add('is-in');
      io.unobserve(en.target);
      setTimeout(function () { en.target.style.transitionDelay = ''; }, 1200);
    });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;

  function arm(root) {
    if (!io || reduce || design) return;
    (root || document).querySelectorAll('[data-hns-reveal]').forEach(function (w) {
      if (w.__hnsArmed) return;
      w.__hnsArmed = true;
      [].forEach.call(w.children, function (c, i) {
        if (c.getBoundingClientRect().top < window.innerHeight * 0.9) return;
        c.classList.add('hns-reveal');
        c.style.transitionDelay = Math.min(i * 70, 280) + 'ms';
        io.observe(c);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { arm(); });
  else arm();
  document.addEventListener('shopify:section:load', function (e) { arm(e.target); });
})();
